module.exports = __webpack_public_path__ + "static/matrix3-81689cf5d44f7496bb4e02ad387b5072.jpg";